import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ImageModal = ({ open, onClose, images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [images, open]);

  const getImageSrc = (index) => {
    const img = images?.[index];
    if (!img) return fallbackImage;
    if (typeof img === 'string') return img;
    if (typeof img === 'object' && (img.url || img.src)) return img.url || img.src;
    return fallbackImage;
  };

  const handleNextImage = () => {
    const len = images?.length ?? 0;
    if (len === 0) return;
    setCurrentImageIndex((prev) => (prev === len - 1 ? 0 : prev + 1));
  };

  const handlePreviousImage = () => {
    const len = images?.length ?? 0;
    if (len === 0) return;
    setCurrentImageIndex((prev) => (prev === 0 ? len - 1 : prev - 1));
  };

  const fallbackImage =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGFsaWdubWVudC1iYXNlbGluZT0ibWlkZGxlIiBmaWxsPSIjNjY2NjY2Ij5JbWFnZW4gbm8gZGlzcG9uaWJsZTwvdGV4dD48L3N2Zz4=';

  const handleImgError = (e) => {
    // si la src actual ya es el fallback, no volver a asignar
    if (!e || !e.target) return;
    if (e.target.src === fallbackImage) return;
    e.target.src = fallbackImage;
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent sx={{ position: 'relative', minHeight: 300, p: 1 }}>
        {images && images.length > 0 ? (
          <Box
            component="img"
            src={getImageSrc(currentImageIndex)}
            alt={`Imagen ${currentImageIndex + 1}`}
            onError={handleImgError}
            sx={{
              width: '100%',
              maxHeight: '70vh',
              objectFit: 'contain',
              backgroundColor: 'background.default',
              display: 'block',
            }}
          />
        ) : (
          <Typography align="center" sx={{ py: 2 }}>
            No hay imágenes disponibles
          </Typography>
        )}

        {images && images.length > 1 && (
          <>
            <IconButton
              onClick={handlePreviousImage}
              sx={{
                position: 'absolute',
                left: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: 'white',
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.8)' },
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>

            <IconButton
              onClick={handleNextImage}
              sx={{
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: 'white',
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.8)' },
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </>
        )}
      </DialogContent>

      <DialogActions>
        {images && images.length > 0 && (
          <Typography variant="body2" sx={{ mr: 'auto', ml: 1 }}>
            {currentImageIndex + 1} / {images.length}
          </Typography>
        )}
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageModal;
